import { render } from "./summary-cod-courier.vue?vue&type=template&id=f8d34ff0&ts=true"
import script from "./summary-cod-courier.vue?vue&type=script&lang=ts"
export * from "./summary-cod-courier.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__